(function () {
    'use strict';

    'use strict';
angular.module('ngKomondorResourceView', ['ng-komondor-resource-view']);
angular.module('ng-komondor-resource-view', ['ui.router', 'ui.bootstrap', 'ngKomondor', 'js-data', 'ng-komondor-resource-view.templates', 'ngTagsInput'])    //https://github.com/js-data/js-data/issues/38
.run(["DSHttpAdapter", function (DSHttpAdapter) {
    DSHttpAdapter.defaults.deserialize = function (resource, data) {
        var result = data;
        resource.meta = {};
        if (result && 'data' in result) {
            result = data.data;
        }
        //Getting metadata and rows
        if (result && 'meta' in result && 'rows' in result) {
            resource.meta = result.meta || {};
            result = result.rows;
        }
        if (data.config.method === 'GET') {
            var count = resource.meta.count || data.headers('x-total-count');
            if (angular.isDefined(count)) {
                resource.getCount = function () {
                    return Number(count);
                };
            }
            var tags = resource.meta.tags || JSON.parse(data.headers('x-tags'));
            if (tags) {
                resource.tags = tags || [];
            }
        }
        return result;
    };
}])    // Automatically convert fields in resource.meta.dates into js date objects
.config(["DSProvider", function (DSProvider) {
    DSProvider.defaults.basePath = '/api/';
    DSProvider.defaults.bypassCache = true;
    function makeDates(model, fields) {
        angular.forEach(fields, function (field) {
            if (!model[field]) {
                return;
            }
            model[field] = new Date(model[field]);
        });
    }
    DSProvider.defaults.beforeInject = function (resource, model) {
        if (!resource.meta || !resource.meta.dates) {
            return;
        }
        if (angular.isArray(model)) {
            angular.forEach(model, function (model) {
                makeDates(model, resource.meta.dates);
            });
        } else {
            makeDates(model, resource.meta.dates);
        }
    };
}])    // Set default configuration for tooltips
.config(['$uibTooltipProvider', function ($uibTooltipProvider) {

    $uibTooltipProvider.options({
        popupDelay: 900,
        appendToBody: true
    });
}]);
'use strict';
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
angular.module('ng-komondor-resource-view').factory('AdminParams', ["$window", "$injector", "resourceState", "localStorageValid", "extendDeep", function ($window, $injector, resourceState, localStorageValid, extendDeep) {
    var AdminParams = function () {
        function AdminParams(stateName, queryDefaults) {
            _classCallCheck(this, AdminParams);
            var viewOptions = AdminParams.getViewOptions(stateName);
            extendDeep(this, angular.copy(queryDefaults), angular.copy(viewOptions.params));
        }
        _createClass(AdminParams, null, [{
                    key: 'key',
                    value: function key(stateName) {
                        return 'admin:params:' + stateName;
                    }
                }, {
                    key: 'getViewOptions',
                    value: function getViewOptions(stateName) {
                        var stateOptions = resourceState.states[stateName];
        
                        return $injector.get(stateOptions.viewOptions);
                    }
                }, {
                    key: 'load',
                    value: function load(stateName) {
                        var viewOptions = this.getViewOptions(stateName);
        
                        if (!localStorageValid()) {
                            return;
                        }
        
                        var json = $window.localStorage.getItem(this.key(stateName));
                        if (!json) {
                            return;
                        }
        
                        viewOptions.params = angular.fromJson(json);
                    }
                }, {
                    key: 'save',
                    value: function save(stateName, params) {
                        var viewOptions = this.getViewOptions(stateName);
        
                        params = angular.copy(params);
        
                        // Remove matching default params from saved params
                        angular.forEach(params, function (value, key) {
                            if (angular.equals(value, viewOptions.queryDefaults[key])) {
                                delete params[key];
                            }
                        });
        
                        viewOptions.params = params;
        
                        if (!localStorageValid()) {
                            return;
                        }
        
                        $window.localStorage.setItem(this.key(stateName), angular.toJson(params));
                    }
                }, {
                    key: 'loadAll',
                    value: function loadAll() {
                        var _this = this;
        
                        angular.forEach(resourceState.states, function (stateOptions, stateName) {
        
                            _this.load(stateName);
                        });
                    }
                }]);
        return AdminParams;
    }();
    return AdminParams;
}]).run(["AdminParams", function (AdminParams) {
    AdminParams.loadAll();
}]);
'use strict';
angular.module('ng-komondor-resource-view').factory('getBreadcrumbs', ["$injector", function ($injector) {
    return function (stateOptions, params) {
        var modelNameField = stateOptions.modelNameField;
        var crumbs = {
            title: '',
            list: []
        };
        var addRootBreadcrumb = function addRootBreadcrumb(crumbs) {
            crumbs.list.splice(0, 0, {
                name: stateOptions.title,
                id: 0
            });
        };
        var Model = $injector.get(stateOptions.model);
        var folderId = params.where.folder_id;
        if (folderId) {
            Model.find(params.where.folder_id, { bypassCache: false }).then(function (instance) {
                crumbs.title = instance[modelNameField];
                addBreadcrumb(instance);
            });
        } else {
            crumbs.title = stateOptions.title;
        }
        function addBreadcrumb(instance) {
            if (instance.folder_id === 0) {
                addRootBreadcrumb(crumbs);
                return;
            }
            Model.find(instance.folder_id, { bypassCache: false }).then(function (instance) {
                crumbs.list.splice(0, 0, {
                    name: instance[modelNameField],
                    id: instance.id
                });
                addBreadcrumb(instance);
            });
        }
        return crumbs;
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view')    /**
 * @deprecated
 */.value('modelExpirationTime', 300)    //5 minutes
                                         /**
 * @deprecated
 */.service('modelsExpired', ["$log", "modelExpirationTime", function ($log, modelExpirationTime) {
    $log.warning('service [modelsExpired] is deprecated');
    var modelExpirationDates = {};
    var getResourceDate = function getResourceDate(resource, params) {
        if (modelExpirationDates[resource.name] === undefined) {
            return null;
        }
        var p = JSON.stringify(params);
        if (modelExpirationDates[resource.name][p] === undefined) {
            return null;
        }
        return modelExpirationDates[resource.name][p];
    };
    var setResourceDate = function setResourceDate(resource, params) {
        var p = JSON.stringify(params);
        if (modelExpirationDates[resource.name] === undefined) {
            modelExpirationDates[resource.name] = {};
        }
        modelExpirationDates[resource.name][p] = new Date();
    };
    this.expired = function (resource, params, forceUpdate) {
        var now = new Date();
        var resourceDate = getResourceDate(resource, params);
        var expired;
        if (resourceDate === null) {
            expired = true;
        } else {
            var diff = Math.floor((now - resourceDate) / 1000);
            expired = diff > modelExpirationTime;
        }
        if (expired || forceUpdate) {
            setResourceDate(resource, params);
        }
        return expired;
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').controller('ResourceFilterCtrl', ["$scope", "Model", "viewOptions", "stateOptions", function ($scope, Model, viewOptions, stateOptions) {
    $scope.model = Model;
    $scope.viewOptions = viewOptions;
    $scope.stateOptions = stateOptions;
    $scope.model.filters = [{
            name: 'Type',
            options: ['normal', 'Business Intelligence']
        }, {
            name: 'Club',
            options: ['Manchester City FC', 'New York City FC', 'Melbourne City FC', 'Yokohama F.Marinos']
        }];
}]);
'use strict';
angular.module('ng-komondor-resource-view').factory('resourceIcons', function () {
    return {
        image: 'material-icon material-icon-photo',
        video: 'material-icon material-icon-play-circle-filled',
        audio: 'material-icon material-icon-audiotrack',
        document: 'material-icon material-icon-file',
        folder: 'material-icon material-icon-folder-open',
        'grid-document': 'material-icon material-icon-grid-document',
        'grid-folder': 'material-icon material-icon-grid-folder'
    };
});
'use strict';
angular.module('ng-komondor-resource-view').factory('ResourceList', function () {
    /**
     * A list of resources with multi-select functionality.
     *
     * @memberOf  ngKomondorResourceView
     * @ngdoc  service
     * @name   ResourceSelector
     * @param  {service} keysHelper
     */
    function ResourceList() {
        /**
         * All items in the resource list
         *
         * @memberOf ResourceSelector
         * @property {Array} all
         */
        this.all = [];
        /**
         * Selected items in the resource list
         *
         * @memberOf ResourceSelector
         * @property {Array} selected
         */
        this.selected = [];
        /**
         * Items selected on last shift action
         *
         * @memberOf ResourceSelector
         * @property {Array} selected
         */
        this.lastShiftSelected = [];
        /**
         * @property {Hash} selectedMap Map of model ids that are selected {model.id: true}
         */
        this.selectedMap = {};
        /**
         * @property {Object} last The item from which ranges will be selected
         */
        this.last = null;
    }
    /**
     * Select the specified items and no others.
     *
     * @memberOf ResourceSelector
     * @param {Array} list The items that need to be selected
     */
    ResourceList.prototype.setSelected = function (list) {
        this.clearSelected();
        angular.forEach(list, this.select, this);
    };
    /**
     * Modify the selection based on the item clicked and the currently held keys.
     *
     * @memberOf ResourceSelector
     * @param {Object} model The clicked item
     */
    ResourceList.prototype.click = function (model, $event) {
        if (this.isSelected(model)) {
            this.clickOnSelected(model, $event);
        } else {
            this.clickOnNotSelected(model, $event);
        }
        if (!isKeyDown('shift', $event)) {
            this.last = model;
        }
    };
    /**
     * Check if the specified item is selected.
     *
     * @memberOf ResourceSelector
     * @param {Object} model The item
     * @return {boolean} True if the item is selected, false otherwise
     */
    ResourceList.prototype.isSelected = function (model) {
        return this.selectedMap[model.id];
    };
    /**
     * Ensure no items are selected.
     *
     * @memberOf ResourceSelector
     */
    ResourceList.prototype.clearSelected = function () {
        this.selectedMap = {};
        this.selected = [];
    };
    // Private function
    ResourceList.prototype.clickOnSelected = function (model, $event) {
        var self = this;
        if (isKeyDown('shift', $event)) {
            var findFunction = function findFunction(model1, model2) {
                return !self.isSelected(model2);
            };
            var actionFunction = function actionFunction(mod) {
                if (mod !== model) {
                    //Don't deselect item clicked on.
                    self.deselect(mod);
                }
            };
            this.shiftFunction(model, findFunction, actionFunction, 'down');
        } else if (isKeyDown('ctrl', $event) || isKeyDown('meta', $event)) {
            this.deselect(model);
        } else {
            if (this.selected.length > 1) {
                this.setSelected([model]);
            } else {
                this.deselect(model);
            }
        }
    };
    // Private function
    ResourceList.prototype.clickOnNotSelected = function (model, $event) {
        var self = this;
        if (isKeyDown('shift', $event)) {
            if (this.last && this.lastShiftSelected.length > 0) {
                angular.forEach(this.lastShiftSelected, this.deselect, this);
            }
            this.lastShiftSelected = [];
            var findFunction = this.last;
            if (!findFunction) {
                findFunction = function findFunction(model1, model2) {
                    return self.isSelected(model2);
                };
            }
            var actionFunction = function actionFunction(mod) {
                self.select(mod);
                self.lastShiftSelected.push(mod);
            };
            this.shiftFunction(model, findFunction, actionFunction, 'up');
        } else if (isKeyDown('ctrl', $event) || isKeyDown('meta', $event)) {
            this.lastShiftSelected = [];
            this.select(model);
        } else {
            this.lastShiftSelected = [];
            this.setSelected([model]);
        }
    };
    // Private function
    ResourceList.prototype.select = function (model) {
        if (this.isSelected(model)) {
            return;
        }
        this.selectedMap[model.id] = model;
        this.selected.push(model);
    };
    // Private function
    ResourceList.prototype.deselect = function (model) {
        delete this.selectedMap[model.id];
        this.selected.splice(this.selected.indexOf(model), 1);
    };
    // Private function
    ResourceList.prototype.shiftFunction = function (model, selectFind, selectChange, direction) {
        direction = direction || 'up';
        var modelTo = null;
        if (angular.isFunction(selectFind)) {
            if (direction === 'down') {
                modelTo = this.findFirstBelow(model, selectFind);
                if (!modelTo) {
                    modelTo = this.findFirstAbove(model, selectFind);
                }
                if (!modelTo) {
                    modelTo = this.all[this.all.length - 1];
                }
            } else if (direction === 'up') {
                modelTo = this.findFirstAbove(model, selectFind);
                if (!modelTo) {
                    modelTo = this.findFirstBelow(model, selectFind);
                }
                if (!modelTo) {
                    modelTo = this.all[0];
                }
            }
        } else {
            modelTo = selectFind;
        }
        if (modelTo) {
            this.modelsIterator(model, modelTo, selectChange);
        }
    };
    // Private function
    ResourceList.prototype.findFirstAbove = function (model, compare) {
        var index = this.all.indexOf(model);
        for (var i = index - 1; i >= 0; i--) {
            if (compare(model, this.all[i])) {
                return this.all[i];
            }
        }
        return null;
    };
    // Private function
    ResourceList.prototype.findFirstBelow = function (model, compare) {
        var index = this.all.indexOf(model);
        for (var i = index + 1; i < this.all.length; i++) {
            if (compare(model, this.all[i])) {
                return this.all[i];
            }
        }
        return null;
    };
    // Private function
    ResourceList.prototype.modelsIterator = function (modelFrom, modelTo, callback) {
        var index1 = this.all.indexOf(modelFrom);
        var index2 = this.all.indexOf(modelTo);
        var indexMin = Math.min(index1, index2);
        var indexMax = Math.max(index1, index2);
        for (var i = indexMin; i <= indexMax; i++) {
            callback(this.all[i]);
        }
    };
    function isKeyDown(keyName, $event) {
        return $event && $event[keyName + 'Key'];
    }
    return ResourceList;
});
'use strict';
angular.module('ng-komondor-resource-view')    /**
 * Resource Picker opens the normal admins screens in a modal, replacing some resolved services
 * and modifying the view options to have only a choose action
 *
 * @memberOf ngKomondorResouceView
 * @name   ResourcePicker
 * @ngdoc  Service
 * @param  {service} $uibModal
 * @param  {service} $injector
 */.factory('ResourcePicker', ["$uibModal", "$injector", "extendDeep", "createAction", "resourceState", function ($uibModal, $injector, extendDeep, createAction, resourceState) {
    /**
     * Fetch the specified view options and modify them for the picker
     * @return {Object} viewOptions
     */
    function makePickerViewOptions(resourcePicker) {
        var viewOptions = angular.copy($injector.get(resourcePicker.options.viewOptions));
        // Clear the toolbar so we can't create new
        viewOptions.toolbar = resourcePicker.options.enableCreate ? [extendDeep({}, createAction, {
                    act: function act() {
                        var modalInstance = $uibModal.open({
                            controller: resourceState[resourcePicker.options.model].edit.controller,
                            templateUrl: resourceState[resourcePicker.options.model].edit.templateUrl,
                            resolve: extendDeep({}, resourceState[resourcePicker.options.model].edit.resolve, resourcePicker.options.resolve, {
                                model: [resourcePicker.options.model, 'modalState', function (Model, modalState) {
                                    modalState.model = Model.createInstance();
                                    return modalState.model;
                                }],
                                folderId: function folderId() {
                                    return viewOptions.params.where.folder_id;
                                }
                            })
                        });
        
                        return modalInstance;
                    }
                })] : resourcePicker.options.toolbar || [];
        // Remove all normal actions
        viewOptions.actions = [];
        // Redefine the click handler
        viewOptions.onItemClick = function ($event, model, force) {
            if ($event) {
                $event.stopPropagation();
            }
            if (resourcePicker.options.chooseFilter([model]) || force) {
                resourcePicker.modal.close([model]);
            }
        };
        // Change the modal title
        viewOptions.modalTitle = resourcePicker.options.title || resourcePicker.options.model + ' picker';
        // Add custom action like objects to the scope for our modal template to use
        viewOptions.chooseCurrent = {
            act: function act() {
                var folderId = viewOptions.params.where.folder_id;
                if (folderId === 0) {
                    resourcePicker.modal.close([{ id: 0 }]);
                } else {
                    $injector.get(resourcePicker.options.model).find(folderId).then(function (model) {
                        resourcePicker.modal.close([model]);
                    });
                }
            },
            show: function show(models) {
                var folderId = viewOptions.params.where && viewOptions.params.where.folder_id;
                if (folderId === undefined) {
                    return false;
                }
                if (models.length > 0) {
                    return false;
                }
                if (!resourcePicker.options.types) {
                    return false;
                }
                return resourcePicker.options.types.indexOf('folder') !== -1;
            }
        };
        // Add custom action like objects to the scope for our modal template to use
        viewOptions.chooseSelected = {
            act: function act(models) {
                resourcePicker.modal.close(models);
            },
            show: function show(models) {
                if (models.length < 1) {
                    return false;
                }
                return resourcePicker.options.chooseFilter(models);
            }
        };
        //Using query from options
        viewOptions.params = extendDeep({}, viewOptions.queryDefaults, resourcePicker.options.params);
        viewOptions.selectedAsset = resourcePicker.options.selectedAsset;
        return viewOptions;
    }
    /**
     *
     * @type {Object}
     */
    var defaultOptions = {
        model: null,
        title: null,
        rootFolderName: null,
        viewOptions: null,
        params: { where: { folder_id: 0 } },
        toolbar: [],
        modelNameField: 'name',
        types: null,
        chooseFilter: function chooseFilter(models) {
            if (!this.types) {
                return true;
            }
            return models.every(function (model) {
                return this.types.indexOf(model.type) !== -1;
            }.bind(this));
        }
    };
    /**
     *
     * @constructor
     * @memberOf  ResourcePicker
     * @parmas {Object} options
     * @parmas {Object} options.types - The types allowed for selection when closing modal
     */
    return function (options) {
        if (!resourceState.models[options.model]) {
            throw new Error('No resource state exists for model ' + options.model);
        }
        /**
         *
         * @type {ResourcePicker}
         */
        var self = this;
        /**
         *
         * @type {Object}
         */
        this.options = angular.extend({}, defaultOptions, options);
        if (this.options.types) {
            this.options.params.where.type = { in: this.options.types.concat('folder') };
        }
        /**
         * The modal instance, used by the choose action
         * @type {Modal}
         */
        this.modal = null;
        /**
         *
         * @type {Object}
         */
        this.stateOptions = resourceState.models[options.model];
        /**
         *
         * @type {Object}
         */
        this.viewOptions = makePickerViewOptions(this);
        // Open the modal
        this.modal = $uibModal.open({
            templateUrl: 'ng-komondor-resource-view/resource-picker.html',
            controller: 'ResourceViewCtrl',
            controllerAs: '$ctrl',
            windowClass: 'media-picker',
            size: 'lg',
            resolve: {
                Model: function Model() {
                    return $injector.get(self.options.model);
                },
                viewOptions: function viewOptions() {
                    return self.viewOptions;
                },
                stateOptions: function stateOptions() {
                    return self.stateOptions;
                },
                parameterStore: function parameterStore() {
                    return null;
                }
            }
        });
        // Provide easier access to the result promise
        this.result = this.modal.result;
        this.result.finally(function () {
            if (self.parameterStore) {
                self.parameterStore.destroy();
            }
        });
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').factory('resourcePreferences', ["$window", "localStorageValid", function ($window, localStorageValid) {
    // Set storage here
    // Note: storage may come from a separate service set in ng-komondor
    var localStorage = localStorageValid() ? $window.localStorage : {}, namespace = 'resourcePreferences';
    localStorage[namespace] = localStorage[namespace] || '{}';
    // Private functions
    /**
     * Get resource namespace object (including all resources preferences)
     * @returns {Object}
     */
    function getPreferences() {
        return angular.fromJson(localStorage[namespace]);
    }
    /**
     * Set a particular resource properties
     * @param resourceName {String}
     * @param properties {*|{}}
     */
    function setResourceProperties(resourceName, properties) {
        var resourcePreferences = getPreferences();
        resourcePreferences[resourceName] = properties;
        localStorage[namespace] = angular.toJson(resourcePreferences);
    }
    /**
     * Get particular resource preferences
     * @param resourceName {String}
     * @returns {*|{}}
     */
    function getResourceProperties(resourceName) {
        var resourcePreferences = getPreferences(), resourceProperties = resourcePreferences[resourceName] || {};
        if (!resourcePreferences[resourceName]) {
            resourcePreferences[resourceName] = resourceProperties;
        }
        return resourceProperties;
    }
    /**
     * Service constructor function
     * @param resourceName {String}
     * @returns {Object}
     */
    return function (resourceName) {
        return {
            /**
             * Get storage object
             * @returns {Storage|{}}
             */
            getStorage: function getStorage() {
                return localStorage;
            },
            /**
             * Get current namespace
             * @returns {string}
             */
            getNamespace: function getNamespace() {
                return namespace;
            },
            /**
             * Get a particular resource property
             * @param propertyName
             * @param defaultValue
             * @returns {*}
             */
            get: function get(propertyName, defaultValue) {
                var properties = getResourceProperties(resourceName);
                if (angular.isUndefined(properties[propertyName])) {
                    return defaultValue;
                }
                return properties[propertyName];
            },
            /**
             * Set a particular resource property
             * @param propertyName {String}
             * @param value {*|{}}
             */
            set: function set(propertyName, value) {
                var properties = getResourceProperties(resourceName);
                properties[propertyName] = value;
                setResourceProperties(resourceName, properties);
            }
        };
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view')    /**
 * @memberof ngKomondorResourceView
 * @ngdoc provider
 * @name resourceStateProvider
 * @param  {service} $stateProvider     From ui.router
 * @param  {service} modalStateProvider From ngKomondor
 * @description
 *     Creates a whole group of states as a CMS for a single js-data resource.
 *     Index, Create/Edit, Delete, and optionally Move
 */.provider('resourceState', ["$stateProvider", "modalStateProvider", function ($stateProvider, modalStateProvider) {
    /**
     * @memberof resourceStateProvider
     * @property {Object} Default options
     */
    var defaultOptions = {
        url: null,
        model: null,
        viewOptions: null,
        modelNameField: 'name',
        edit: {
            controller: 'EditCtrl',
            templateUrl: 'ng-komondor-resource-view/edit.html',
            defaults: {}
        },
        root: {
            resolve: {},
            onEnter: null,
            views: {
                '': {
                    templateUrl: 'ng-komondor-resource-view/ribbon.html',
                    controller: 'ResourceViewCtrl',
                    controllerAs: '$ctrl'
                }
            }
        },
        delete: true,
        deleteCheckDependencies: false,
        breadcrumbs: false,
        // At the moment used for switching on folder move and edit states
        // TODO: rename this option to reflect that
        move: false
    };
    this.stateOptions = {
        states: {},
        models: {}
    };
    this.$get = [function () {
            return this.stateOptions;
        }];
    /**
     * Create a group of states as a CMS for a js-data resource.
     * @memberOf resourceStateProvider
     * @param {string} stateName - The index state for the resource 'admin.users'.
     * @param {Object} options - An object used to override or augment the states configuration. Currently
     * angular.extend is used **not extendDeep**.
     * @param {string} options.url - The url part to append to the parent state.
     * @param {string} options.model - The injectable name for the js-data resource definition.
     * @param {string} options.viewOptions - The injectable name for the viewOptions to use for the the resource view.
     * @param {string} [options.modelNameField=name] - The property on the model in which you find the name.
     * @param {Object} options.edit
     * @param {string} [options.edit.controller=EditCtrl] - The injectable name of the controller to use for the
     * Edit/Create state.
     * @param {string} [options.edit.templateUrl=ng-komondor-resource-view/edit.html] - The template for the
     * Edit/Create state.
     * @param {Object} options.edit.defaults - Default propertiy values to use when creating a new instance of the
     * resource.
     * @param {Object} options.root
     * @param {Object} options.root.resolve - ui.router resolve object that can augment or override the stardard
     * resolves.
     * @param {Object} options.root.views - ui.router views object, defaults to putting the standard view and controller
     * in the default ui-view in the parent state.
     * @param {boolean} [options.delete=true] - Creates a delete state if true (default true).
     * @param {boolean} [options.deleteCheckDependencies=false] - Checks model dependencies on delete (default false).
     * @param {boolean} [options.move=false] - Creates a move state if true (default false).
     */
    this.state = function (stateName, options) {
        options = angular.extend({}, defaultOptions, options);
        options.name = stateName;
        // @deprecated
        this.stateOptions[options.model] = options;
        this.stateOptions.models[options.model] = options;
        this.stateOptions.states[stateName] = options;
        var defaultQuery = ['limit', 'sort', 'offset', 'search', options.modelNameField];
        var args = '?' + defaultQuery.concat(options.query || []).join('&');
        $stateProvider.state(stateName, {
            url: '/' + options.url + args,
            params: options.params,
            reloadOnSearch: false,
            views: angular.extend({}, defaultOptions.root.views, options.root.views),
            onEnter: options.root.onEnter,
            onExit: ['parameterStore', function (parameterStore) {
                            parameterStore.destroy();
                        }],
            resolve: angular.extend({
                Model: [options.model, function (Model) {
                                    return Model;
                                }],
                viewOptions: [options.viewOptions, function (viewOptions) {
                                    return viewOptions;
                                }],
                stateOptions: [function () {
                                    return options;
                                }],
                parameterStore: ['SearchParams', 'viewOptions', function (SearchParams, viewOptions) {
                                    return new SearchParams(viewOptions.queryDefaults, new RegExp('/' + options.url + '(/|\\?|$)'));
                                }]
            }, options.root.resolve)
        });
        if (options.edit) {
            options.edit = angular.extend(options.edit, {
                reloadOnExit: true,
                url: '/edit/{id:[0-9w-]+}',
                resolve: angular.extend({
                    model: [options.model, 'modalState', function (Model, modalState) {
                                            if (!parseInt(modalState.stateParams.id)) {
                                                modalState.model = Model.createInstance(options.edit.defaults);
                                                return modalState.model;
                                            }
                    
                                            return Model.find(modalState.stateParams.id).then(function (data) {
                                                modalState.model = data;
                                                return modalState.model;
                                            });
                                        }],
                    modelNameField: [function () {
                                            return options.modelNameField;
                                        }],
                    folderId: ['$state', '$stateParams', function ($state, $stateParams) {
                                            return $stateParams.folder_id;
                                        }]
                }, options.edit.resolve),
                onDismiss: function onDismiss(modalState) {
                    if (modalState.model.id) {
                        modalState.model.DSRevert();
                    }
                }
            });
            modalStateProvider.state(stateName + '.edit', options.edit);
        }
        var getModelsByIds = function getModelsByIds(Model, ids, withDependencies) {
            var arr = ids.split(',').map(Number);
            var query = { where: { id: { in: arr } } };
            if (withDependencies) {
                query.with = 'dependencies';
            }
            return Model.findAll(query).then(function () {
                if (query.with) {
                    delete query.with;
                }
                return Model.filter(query);
            });
        };
        if (options.delete) {
            modalStateProvider.state(stateName + '.delete', {
                url: '/delete/{ids}',
                controller: 'DeleteCtrl',
                templateUrl: 'ng-komondor-resource-view/delete.html',
                resolve: {
                    models: [options.model, 'modalState', function (Model, modalState) {
                                            return getModelsByIds(Model, modalState.stateParams.ids, options.deleteCheckDependencies);
                                        }],
                    modelName: [options.model, function (Model) {
                                            return Model.name;
                                        }],
                    modelNameField: [function () {
                                            return options.modelNameField;
                                        }],
                    Model: [options.model, function (Model) {
                                            return Model;
                                        }]
                }
            });
        }
        if (options.move) {
            modalStateProvider.state(stateName + '.move', {
                url: '/move/{ids}',
                controller: 'MoveCtrl',
                templateUrl: 'ng-komondor-resource-view/move.html',
                resolve: {
                    models: [options.model, 'modalState', function (Model, modalState) {
                                            return getModelsByIds(Model, modalState.stateParams.ids);
                                        }],
                    moveOptions: [function () {
                                            return {};
                                        }],
                    modelNameField: [function () {
                                            return options.modelNameField;
                                        }],
                    Model: [options.model, function (Model) {
                                            return Model;
                                        }]
                }
            });
            modalStateProvider.state(stateName + '.editFolder', {
                url: '/edit-folder/{id:[0-9]+}',
                controller: 'EditFolderCtrl',
                controllerAs: '$ctrl',
                templateUrl: 'ng-komondor-resource-view/edit-folder.html',
                resolve: {
                    tagging: [options.viewOptions, function (viewOptions) {
                                            return viewOptions.tagging;
                                        }],
                    modelNameField: function modelNameField() {
                        return options.modelNameField;
                    },
                    model: [options.model, 'modalState', function (Model, modalState) {
                                            if (!parseInt(modalState.stateParams.id)) {
                                                modalState.model = Model.createInstance({
                                                    type: 'folder',
                                                    folder_id: modalState.stateParams.folder_id
                                                });
                    
                                                return modalState.model;
                                            }
                    
                                            return Model.find(modalState.stateParams.id).then(function (data) {
                                                modalState.model = data;
                    
                                                return modalState.model;
                                            });
                                        }],
                    actions: ['Action', function (Action) {
                                            return Action.findAll();
                                        }]
                },
                onDismiss: function onDismiss(modalState) {
                    if (modalState.model.id) {
                        modalState.model.DSRevert();
                    }
                }
            });
        }
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').controller('ResourceViewCtrl', ["$scope", "$log", "$state", "Model", "viewOptions", "stateOptions", "getBreadcrumbs", "parameterStore", "ResourceList", "resourceState", "resourcePreferences", "AdminParams", "DS", function ($scope, $log, $state, Model, viewOptions, stateOptions, getBreadcrumbs, parameterStore, ResourceList, resourceState, resourcePreferences, AdminParams, DS) {
    var _this = this;
    var $ctrl = this;
    this.modelNameField = stateOptions.modelNameField;
    var preferences = resourcePreferences(stateOptions.model);
    /**
     * Keeping a copy of previous query params
     * so we a able to compare and see what's changed.
     *
     * @type {null}
     */
    this.previousParams = null;
    this.search = null;
    this.options = viewOptions;
    this.resourceFilters = this.options.resourceFilters;
    this.filtersSelected = [];
    if (!this.options.resourceList) {
        this.options.resourceList = new ResourceList();
    }
    this.resourceList = this.options.resourceList;
    /**
     * Initialise variables on the scope and attach event listeners
     */
    this.init = function () {
        _this.buildSorts();
        _this.name = resourceState.states[stateOptions.name].viewOptions;
        _this.params = new AdminParams(stateOptions.name, _this.options.queryDefaults);
        if (_this.options.params.where) {
            _this.params.where.type = _this.options.params.where.type;
        }
        _this.options.params = _this.params;
        // If the parameter store changes we should make a new request
        if (parameterStore) {
            parameterStore.onChange(_this.onParameterStoreChange);
            _this.params = parameterStore.get();
        }
        _this.setInitialFilters();
        // If the js-data store changes we should update our view
        $scope.$watch(_this.lastModified, _this.updatePaging);
        DS.on('media-file-uploaded', _this.refreshModels);
        $scope.$on('$destroy', _this.onDestroy);
        if (_this.options.tagging) {
            var tagsMapped = false;
            _this.tags = {
                show: preferences.get('tags.show', false),
                advanced: _this.options.taggingAdvanced,
                filter: {},
                pool: [],
                filterAny: true,
                //true - ANY (has any of the tags), false - ALL (has all the tags)
                getMethod: function getMethod() {
                    return _this.tags.filterAny ? 'isectNotEmpty' : 'isectEmpty';
                },
                isEmpty: function isEmpty() {
                    for (var tagId in _this.tags.filter) {
                        if (_this.tags.filter[tagId] === true) {
                            return false;
                        }
                    }
                    return true;
                }
            };
            // Binding tags..
            $scope.$watch(function () {
                return Model.tags;
            }, function () {
                _this.tags.pool = Model.tags;
                if (!tagsMapped && _this.tags.pool) {
                    tagsMapped = true;
                    _this.mapQueryTagSelection();
                }
            }, true);
        }
        if (viewOptions.selectedAsset) {
            _this.goToFolder(viewOptions.selectedAsset.folder_id);
        }
    };
    this.onDestroy = function () {
        DS.off('media-file-uploaded', _this.refreshModels);
    };
    this.checkLoadedModels = function () {
        var numModels = Model.filter().length;
        if (numModels !== _this.numModelsLoaded) {
            _this.numModelsLoaded = numModels;
            _this.refreshModels();
        }
    };
    // View state
    this.ribbon = {
        view: this.options.getView(),
        nextView: this.options.getView(+1),
        goToNextView: function goToNextView() {
            $ctrl.options.viewIndex++;
            if ($ctrl.options.viewIndex >= $ctrl.options.views.length) {
                $ctrl.options.viewIndex = 0;
            }
            this.view = $ctrl.options.getView();
            this.nextView = $ctrl.options.getView(+1);
        }
    };
    this.paging = {
        page: 1,
        first: function first() {
            this.page = 1;
            this.goToPage(this.page);
        },
        prev: function prev() {
            this.page = Math.max(1, --this.page);
            this.goToPage(this.page);
        },
        next: function next() {
            this.page = Math.min(this.getLastPage(), ++this.page);
            this.goToPage(this.page);
        },
        last: function last() {
            this.page = this.getLastPage();
            this.goToPage(this.page);
        },
        getLastPage: function getLastPage() {
            return $ctrl.params.limit ? Math.ceil($ctrl.showing.total / $ctrl.params.limit) : 1;
        },
        goToPage: function goToPage(page) {
            $ctrl.params.offset = (page - 1) * parseInt($ctrl.params.limit);
            $ctrl.refreshModels();
        }
    };
    this.goToFolder = function (id) {
        _this.params.where.folder_id = id;
        _this.params.offset = 0;
        delete _this.params.where[_this.modelNameField];
        _this.refreshModels();
    };
    this.goToModel = function ($event, model) {
        if (model.type === 'folder') {
            $event.stopPropagation();
            _this.goToFolder(model.id);
            return;
        }
        viewOptions.onItemClick($event, model);
    };
    this.onParameterStoreChange = function () {
        var params = parameterStore.get();
        if (!angular.equals(_this.params, params)) {
            $log.debug('Params changed in location');
            _this.params = params;
            _this.saveParams();
            _this.refreshModels();
        } else {
            $log.debug('Location changed but params are the same');
        }
    };
    this.toggleTagPool = function () {
        _this.tags.show = !_this.tags.show;
        preferences.set('tags.show', _this.tags.show);
    };
    this.tagFilterChanged = function () {
        var filter = [];
        var method = _this.tags.getMethod();
        for (var o in _this.tags.filter) {
            if (_this.tags.filter[o]) {
                filter.push(parseInt(o));
            }
        }
        // Hack: keep this
        // The $http adapter for js-data seems to convert an isectNotEmpty
        // filter with only one item, to a flat where query
        //
        // E.g.
        // this.params = { where: { tagIDs: { isectNotEmpty: [1] } } }
        // $http query = { where: { tagIDs: 1 } }
        if (filter.length === 1) {
            filter.push(filter[0]);
        }
        _this.params.offset = 0;
        if (filter.length) {
            _this.params.where.tagIDs = {};
            _this.params.where.tagIDs[method] = filter;
        } else {
            delete _this.params.where.tagIDs;
        }
        _this.refreshModels();
    };
    this.searchChanged = function (search) {
        // Back to first page after search
        _this.params.offset = 0;
        delete _this.params.where[_this.modelNameField];
        if (search.value) {
            _this.params.where[_this.modelNameField] = {};
            _this.params.where[_this.modelNameField].likei = search.value;
        }
        _this.refreshModels();
    };
    /**
     * @deprecated
     */
    this.paramsChanged = function () {
        _this.refreshModels();
    };
    this.setLimit = function (limit) {
        _this.params.limit = limit;
        _this.params.offset = 0;
        _this.refreshModels();
    };
    this.setSort = function (sort) {
        _this.params.sort = sort;
        _this.refreshModels();
    };
    this.saveParams = function () {
        _this.previousParams = angular.copy(_this.params);
        AdminParams.save(stateOptions.name, _this.params);
        if (parameterStore) {
            parameterStore.set(_this.params);
        }
    };
    this.lastModified = function () {
        return Model.lastModified();
    };
    this.bindModels = function (result) {
        _this.resourceList.all = result;
    };
    this.updateBreadcrumbs = function () {
        _this.breadcrumbs = getBreadcrumbs(stateOptions, _this.params);
    };
    this.refreshModels = function () {
        _this.validateParams(_this.params);
        _this.saveParams();
        _this.calcPage();
        // If offset changed, need to recalculate page number.
        _this.updateBreadcrumbs();
        _this.findCurrentSort();
        _this.resourceList.clearSelected();
        var params = angular.copy(_this.params);
        // Add rest of with to query
        params.with = _this.options.with.join(',');
        // Add search
        var isSearching = _this.params.where[_this.modelNameField] && _this.params.where[_this.modelNameField].likei;
        var isTagFiltered = params.where && params.where.tagIDs;
        _this.options.showBreadcrumbs = stateOptions.breadcrumbs && isSearching || isTagFiltered;
        // Don't filter by folder if searching or filtering by tag.
        if (isSearching || isTagFiltered) {
            delete params.where.folder_id;
        }
        if (_this.options.showBreadcrumbs) {
            params.with += (params.with.length ? ',' : '') + 'breadcrumbs';
        }
        Model.findAll(params).then(_this.bindModels);
    };
    this.calcOffset = function () {
        var page = parseInt(_this.paging.page);
        _this.params.offset = page ? (page - 1) * parseInt(_this.params.limit) : 0;
    };
    this.calcPage = function () {
        var perPage = parseInt(_this.params.limit);
        var page = perPage ? parseInt(_this.params.offset) / perPage : 0;
        _this.paging.page = Math.max(1, page + 1);
    };
    this.getShowingResults = function (params) {
        var numResults;
        // For lists which are not paginated..
        if (angular.isFunction(Model.getCount)) {
            numResults = Model.getCount();
        } else {
            var copy = angular.copy(params);
            delete copy.limit;
            delete copy.offset;
            numResults = Model.filter(copy).length;
        }
        var start = params.offset === undefined ? 1 : params.offset + 1;
        return {
            start: numResults === 0 ? 0 : start,
            end: Math.min(start + params.limit - 1, numResults),
            total: numResults
        };
    };
    this.updatePaging = function () {
        _this.checkLoadedModels();
        _this.showing = _this.getShowingResults(_this.params);
        _this.resourceInfo = _this.showing.start + ' - ' + _this.showing.end + ' of ' + _this.showing.total;
    };
    this.validateParams = function (params) {
        if (_this.previousParams && !angular.equals(_this.previousParams.where, params.where)) {
            params.offset = 0;
        }
        params.offset = Math.max(0, params.offset);
        params.limit = Math.max(1, params.limit);
        var tagMethod = _this.tags ? _this.tags.getMethod() : null;
        if (params.where && params.where.tagIDs && tagMethod && params.where.tagIDs[tagMethod]) {
            var tagIds = [];
            angular.forEach(params.where.tagIDs[tagMethod], function (value) {
                tagIds.push(parseInt(value));
            });
            params.where.tagIDs[tagMethod] = tagIds;
        }
    };
    this.mapQueryTagSelection = function () {
        // pre-select tag from tagpool according to the current this.params
        if (_this.params.where.tagIDs) {
            var filter;
            if (typeof _this.params.where.tagIDs === 'number') {
                filter = [_this.params.where.tagIDs];
            } else {
                var tagMethod = Object.keys(_this.params.where.tagIDs)[0];
                _this.tags.filterAny = tagMethod === 'isectNotEmpty';
                filter = _this.params.where.tagIDs[tagMethod];
            }
            for (var i = 0; i < filter.length; i++) {
                filter[i] = Number(filter[i]);
            }
            for (i = 0; i < _this.tags.pool.length; i++) {
                if (filter.indexOf(_this.tags.pool[i].id) > -1) {
                    _this.tags.filter[_this.tags.pool[i].id] = true;
                }
            }
        }
    };
    /**
     * Properly build the required information for the sort option list
     *
     * @deprecated  This function shouldn't be here, it should be done
     *              when view options are registered.
     */
    this.buildSorts = function () {
        _this.sorts = [];
        viewOptions.sorts.forEach(function (sort) {
            _this.sorts.push(sort);
        });
        // Also add single column sorts to the list
        viewOptions.list.columns.forEach(function (col) {
            if (!col.sortable) {
                return;
            }
            _this.sorts.push({
                label: col.label,
                sort: col.name + ' asc'
            });
        });
        _this.sorts.forEach(function (sort) {
            sort.reverse = _this.flipSort(sort.sort);
        });
        // Set queryDefaults.sort if set or first one of list as default sort
        var defaultSort = _this.options.queryDefaults.sort || _this.sorts[0].sort;
        viewOptions.queryDefaults.sort = defaultSort;
    };
    /**
     * Turn all asc -> desc and desc -> asc
     * @param  {string} sortValue E.g. 'field asc,field2 desc'
     * @return {string} Opposite E.g. 'field desc,field2 asc'
     */
    this.flipSort = function (sortValue) {
        var sort = sortValue.split(',');
        for (var i = 0; i < sort.length; i++) {
            var col = sort[i].split(' ');
            col[1] = col[1] === 'asc' ? 'desc' : 'asc';
            sort[i] = col.join(' ');
        }
        return sort.join(',');
    };
    this.findCurrentSort = function () {
        for (var i = 0; i < _this.sorts.length; i++) {
            var sort = _this.sorts[i];
            if (sort.sort === _this.params.sort) {
                _this.selectedSort = sort;
                _this.sortReversed = false;
                return;
            } else if (sort.reverse === _this.params.sort) {
                _this.selectedSort = sort;
                _this.sortReversed = true;
                return;
            }
        }
        $log.warn('Sort not found:', _this.params.sort, _this.sorts);
        _this.selectedSort = null;
        _this.sortReversed = false;
    };
    this.toggleSortDirection = function () {
        _this.params.sort = _this.flipSort(_this.params.sort);
        _this.refreshModels();
    };
    this.setInitialFilters = function () {
        _this.resourceFilters.forEach(function (filter) {
            if (_this.params.where[filter.name] && _this.params.where[filter.name]['===']) {
                var current = filter.options.find(function (option) {
                    return option.value === _this.params.where[filter.name]['==='];
                });
                _this.filtersSelected[filter.value] = current.label;
            } else {
                _this.filtersSelected[filter.value] = filter.defaultValueLabel;
            }
        });
    };
    this.setResourceFilter = function (filter, option) {
        if (option.value) {
            _this.params.where[filter.name] = {};
            _this.params.where[filter.name] = option.value;
        } else {
            delete _this.params.where[filter.name];
        }
        _this.filtersSelected[filter.value] = option.label;
        _this.refreshModels();
    };
    this.init();
}]);
'use strict';
angular.module('ng-komondor-resource-view').factory('resourceViewOptions', ["createAction", "editAction", "deleteAction", "deselectAction", "listView", "gridView", "listNameTemplate", "gridNameTemplate", "gridThumbTemplate", "resourceIcons", function (createAction, editAction, deleteAction, deselectAction, listView, gridView, listNameTemplate, gridNameTemplate, gridThumbTemplate, resourceIcons) {
    return {
        selectedMap: {},
        selected: [],
        with: [],
        queryDefaults: {
            limit: 50,
            offset: 0,
            where: {}
        },
        params: {},
        toolbar: [createAction],
        actions: [deselectAction, editAction, deleteAction],
        limitOptions: [25, 50, 75, 100],
        tagging: false,
        filters: { templateUrl: null },
        onItemClick: function onItemClick($event, model) {
            $event.stopPropagation();
            editAction.act([model]);
        },
        rowClassifier: function rowClassifier(model, classes) {
            return classes;
        },
        getIcon: function getIcon(model, isGrid) {
            var prefix = isGrid ? 'grid-' : '';
            return prefix && resourceIcons[prefix + model.type] ? resourceIcons[prefix + model.type] : resourceIcons[model.type];
        },
        list: {
            tableClass: 'table table-striped',
            columns: [{
                            label: 'Name',
                            name: 'name',
                            template: listNameTemplate('name', 'links.thumb'),
                            sortable: true
                        }, {
                            label: 'Last modified',
                            name: 'updated_at',
                            template: '<span>{{ model.updated_at | date }}</span>',
                            sortable: true
                        }]
        },
        grid: {
            fields: [{
                            template: gridThumbTemplate('thumb')
                        }, {
                            template: gridNameTemplate('name', 'type')
                        }]
        },
        viewIndex: 0,
        views: [listView, gridView],
        getView: function getView(modifier) {
            var idx = this.viewIndex;
            if (modifier) {
                idx += modifier;
            }
            if (idx >= this.views.length) {
                idx = 0;
            }
            return this.views[idx];
        },
        /**
         * Define the list of available sorts
         * sorts: [
         *     {
         *         label: 'Nice Sort',
         *         sort: 'type asc,name asc',
         *     },
         *     ...
         * ]
         */
        sorts: [],
        /**
         * Define the list of available resource filters
         * resourceFilters: [
         *     {
         *          label: 'Status',
         *          name: 'status',
         *          defaultValueLabel: 'All',
         *          options: [
         *           {
         *               label: 'All', value: ''
         *           },
         *           {
         *               label: 'Approved', value: 'approved'
         *           },
         *           {
         *               label: 'Rejected', value: 'rejected'
         *           },
         *           {
         *               label: 'Pending', value: 'pending'
         *           }
         *       ]
         *   },
         *     ...
         * ]
         */
        resourceFilters: []
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').directive('standardAction', ["$compile", function ($compile) {
    return {
        restrict: 'A',
        scope: {
            action: '=standardAction',
            models: '=',
            options: '=',
            admin: '='
        },
        link: function link(scope, element) {
            if (scope.action.name) {
                element.attr('id', 'admin-action-' + scope.action.name);
            }
            if (scope.action.template) {
                var template = $compile(scope.action.template);
                var child = template(scope);
                element.append(child);
            } else {
                element.text(scope.action.label);
            }
        }
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').directive('standardField', ["$compile", "$parse", "$http", "$templateCache", function ($compile, $parse, $http, $templateCache) {
    return {
        restrict: 'A',
        scope: {
            field: '=standardField',
            model: '=',
            options: '=',
            admin: '='
        },
        link: function link(scope, element) {
            if (scope.field.name) {
                element.addClass('admin-field-' + scope.field.name);
            }
            if (scope.field.templateUrl) {
                $http.get(scope.field.templateUrl, { cache: $templateCache }).success(function (template) {
                    element.append($compile(template)(scope));
                });
                return;
            }
            if (!scope.field.template) {
                scope.field.template = '<span>{{ model.' + scope.field.name + '}}<span>';
            }
            element.append($compile(scope.field.template)(scope));
        }
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').component('kdSearch', {
    controller: 'KdSearch',
    templateUrl: 'ng-komondor-resource-view/search/search.html',
    bindings: {
        field: '<',
        value: '<',
        operator: '<',
        onChange: '&'
    }
});
'use strict';
angular.module('ng-komondor-resource-view').controller('KdSearch', function () {
    this.field = this.field || 'name';
    this.operator = this.operator || 'likei';
    this.value = this.value || null;
    this.active = this.value ? true : false;
    this.toggleActive = function () {
        this.active = !this.active;
        if (!this.active) {
            this.clear();
        }
    };
    this.clear = function () {
        this.value = null;
        this.active = false;
        this.emitChange();
    };
    /**
     * Because this control isn't in its own form,
     * pressing enter on the input messes with the filters form
     */
    this.handleKeydown = function ($event) {
        // keycode 13 = ENTER
        if ($event.keyCode === 13) {
            $event.preventDefault();
        }
    };
    this.emitChange = function () {
        this.onChange({
            search: {
                field: this.field,
                operator: this.operator,
                value: this.value ? '%' + this.value + '%' : null
            }
        });
    };
    this.$onChanges = function (changes) {
        if (changes.value.currentValue) {
            this.value = changes.value.currentValue.replace(/^%/, '').replace(/%$/, '');
        } else {
            this.value = null;
        }
    };
});
'use strict';
angular.module('ng-komondor-resource-view').directive('adminSref', function () {
    return {
        restrict: 'A',
        require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
        controller: ["$scope", "$element", "$attrs", "$injector", "$state", "resourceState", "SearchParams", function controller($scope, $element, $attrs, $injector, $state, resourceState, SearchParams) {
            var _this = this;
            this.state = $attrs.adminSref;
            this.stateOptions = resourceState.states[this.state];
            this.viewOptions = $injector.get(this.stateOptions.viewOptions);
            this.$onInit = function () {
                _this.active = $element.controller('uiSrefActive') || $element.controller('uiSrefActiveEq');
            };
            // Change the href when the state's params are saved
            $scope.$watch(function () {
                return _this.viewOptions.params;
            }, function (params) {
                var query = SearchParams.getQuery(params, _this.viewOptions.queryDefaults);
                $element.attr('href', $state.href(_this.state, query));
            });
            // Update ui-sref-active
            $scope.$on('$stateChangeSuccess', function () {
                if (_this.active) {
                    _this.active.$$addStateInfo(_this.state, {});
                }
            });
        }]
    };
});
'use strict';
angular.module('ng-komondor-resource-view').component('contextualOptions', {
    bindings: {
        actions: '=',
        dropdownActions: '=',
        model: '=',
        models: '<'
    },
    controller: function controller() {
        var _this = this;
        this.hasDropdownActions = true;
        this.$onInit = function () {
            _this.hasDropdownActions = _this.dropdownActions ? _this.dropdownActions.some(function (action) {
                return action.show(_this.model);
            }) : false;
        };
        this.show = function () {
            if (_this.models.length === 1 && _this.models[0].id === _this.model.id) {
                return 'visible';
            }
            return 'hidden';
        };
        this.hideActions = function () {
            return _this.models.length <= 1;
        };
        this.hideDropdown = function () {
            return _this.hasDropdownActions && _this.hideActions();
        };
        this.isSelected = function ($event) {
            if (_this.models.some(function (m) {
                    return m === _this.model;
                })) {
                $event.stopPropagation();
            }
        };
    },
    template: '\n            <div class="contextual-options text-right"\n                 ng-style="{\'visibility\': $ctrl.show()}">\n                <button ng-repeat="button in ::$ctrl.actions track by $index"\n                        ng-show="button.show($ctrl.model)" \n                        ng-if="$ctrl.hideActions()"\n                        ng-click="button.act([$ctrl.model]);$event.stopPropagation()"\n                        type="button"\n                        style="padding: 0 !important;transition:none;"\n                        class="btn btn-transparent"\n                        uib-tooltip="{{ ::button.tooltip }}">\n                    <span ng-bind-html="::button.template"\n                          class="contextual-options-template"></span>\n                </button>\n                <span uib-dropdown \n                      ng-if="$ctrl.dropdownActions && $ctrl.hideDropdown()">\n                    <button uib-dropdown-toggle\n                            style="padding: 0 15px 0 0 !important;transition:none;"\n                            class="btn btn-transparent"\n                            ng-click="$ctrl.isSelected($event)">\n                        <i class="material-icon material-icon-more-horiz"></i>\n                    </button>\n                    <ul uib-dropdown-menu class="dropdown-menu">\n                        <li ng-repeat="button in ::$ctrl.dropdownActions track by $index"\n                            ng-show="button.show($ctrl.model)">\n                            <button type="button"\n                                    class="btn btn-block btn-white"\n                                    ng-click="button.act([$ctrl.model]);">\n                                <span>{{ button.tooltip }}</span>\n                            </button>\n                        </li>\n                    </ul>\n                </span>\n            </div>'
});
'use strict';
angular.module('ng-komondor-resource-view')    /**
 * @ngdoc directive
 * @name Resource Picker Directive
 * @description The model must have a resource state defined for the picker to work
 *
 * @example
 * <any resource-picker="User" ng-model="object.user_id"></any>
 *
 * @example
 * <any resource-picker="Asset" ng-model="object.media_folder_id"
 *         folder-picker></any>
 *
 * @example
 * <any resource-picker="Asset" ng-model="object.asset_id"
 *         query="{where: {type: {in: ['folder', 'image']}}}"
 *         choose-filder="$ctrl.isSingleImage"></any>
 *
 * this.isSingleImage = function (models)
 * {
 *     return models.length === 1 && models[0].type === 'image';
 * };
 */.directive('resourcePicker', ["DS", "ResourcePicker", "resourceState", "extendDeep", function (DS, ResourcePicker, resourceState, extendDeep) {
    function link($scope, element, attrs, ngModel) {
        element.addClass('resource-picker');
        var stateOptions = angular.copy(resourceState.models[$scope.modelName]);
        if (!stateOptions) {
            throw new Error('No resource state defined for model [' + $scope.modelName + '].');
        }
        var options = {
            viewOptions: stateOptions.viewOptions,
            model: stateOptions.model,
            modelNameField: stateOptions.modelNameField,
            enableCreate: false,
            toolbar: [],
            query: {
                where: {},
                offset: 0,
                limit: 50
            }
        };
        // Apply custom params for this directive instance
        if ($scope.query) {
            extendDeep(options.query, $scope.query);
        }
        // Apply custom choose filter for this directive instance
        if ($scope.chooseFilter) {
            options.chooseFilter = $scope.chooseFilter;
        }
        // Shortcut to apply folder picker using attribute
        if (attrs.folderPicker !== undefined) {
            options.types = ['folder'];
        } else if ($scope.types) {
            options.types = $scope.types.split(',');
        }
        $scope.ngModel = ngModel;
        $scope.modelNameField = stateOptions.modelNameField || 'name';
        $scope.getDescription = function () {
            var value = ngModel.$viewValue;
            if (value === null) {
                return '-';
            }
            if (value === 0) {
                return $scope.modelName;
            }
            if ($scope.model && $scope.model[$scope.modelNameField]) {
                return $scope.model[$scope.modelNameField];
            }
            return '???';
        };
        $scope.selectedAssets = function (models) {
            ngModel.$setViewValue(models[0].id);
        };
        $scope.clear = function () {
            var value = angular.isUndefined($scope.clearValue) ? 0 : $scope.clearValue;
            ngModel.$setViewValue(value);
        };
        $scope.openResourcePicker = function openResourcePicker() {
            var picker = new ResourcePicker(options);
            picker.result.then(function (data) {
                $scope.selectedAssets(data);
            });
        };
        function bindModel() {
            $scope.model = null;
            if (!ngModel.$modelValue) {
                return;
            }
            DS.find(stateOptions.model, ngModel.$modelValue, { bypassCache: false }).then(function (model) {
                $scope.model = model;
            });
        }
        function modelValue() {
            return ngModel.$modelValue;
        }
        $scope.$watch(modelValue, bindModel);
    }
    return {
        require: 'ngModel',
        scope: {
            modelName: '@resourcePicker',
            query: '<?',
            types: '@',
            chooseFilter: '=?',
            clearValue: '=?',
            buttonId: '@?'
        },
        link: link,
        templateUrl: 'ng-komondor-resource-view/resource-picker-control.html'
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').directive('tagsEdit', ["Tag", function (Tag) {
    controller.$inject = ["$scope"];
    function controller($scope) {
        $scope.searchTags = function (query) {
            return Tag.findAll({ where: { name: { contains: query } } });
        };
    }
    return {
        restrict: 'AE',
        scope: { model: '=' },
        controller: controller,
        template: '<div form-group="tags">' + '<label class="control-label" for="tags">Tags</label>' + '<tags-input max-length="25" replace-spaces-with-dashes="false" class="tags-input" ng-model="model.tags"' + 'display-property="name" min-length="2">' + '<auto-complete source="searchTags($query)" min-length="2"></auto-complete>' + '</tags-input>' + '</div>'
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').run(["Tag", function (Tag) {
}])    // jshint ignore:line
.factory('Tag', ["DS", function (DS) {
    return DS.defineResource({
        basePath: '/api/',
        name: 'Tag',
        endpoint: 'tags',
        upsert: true
    });
}]);
'use strict';
var _typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
};
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
/**
 * Store and retrieve js-data filter params from the search portion of $location
 * http://www.js-data.io/v1.8.0/docs/query-syntax
 */
angular.module('ng-komondor-resource-view').factory('SearchParams', ["$rootScope", "$location", function ($rootScope, $location) {
    var SearchParams = function () {
        function SearchParams(queryDefaults, pattern) {
            var _this = this;
            _classCallCheck(this, SearchParams);
            this.defaults = queryDefaults;
            this.pattern = pattern;
            this.callback = null;
            this.locationChangeHandler = $rootScope.$on('$locationChangeSuccess', function () {
                if (_this.callback && _this.pattern.test($location.path())) {
                    _this.callback();
                }
            });
        }
        _createClass(SearchParams, [{
                    key: 'get',
                    value: function get() {
                        var query = $location.search();
                        var params = angular.copy(this.defaults);
        
                        angular.forEach(query, function (value, key) {
                            SearchParams.queryToParam(params, key, value);
                        });
        
                        return params;
                    }
                }, {
                    key: 'set',
                    value: function set(params) {
                        var query = SearchParams.getQuery(params, this.defaults);
        
                        $location.search(query);
                    }
                }, {
                    key: 'onChange',
                    value: function onChange(callback) {
                        this.callback = callback;
                    }
                }, {
                    key: 'destroy',
                    value: function destroy() {
                        if (this.locationChangeHandler) {
                            this.locationChangeHandler();
                        }
        
                        this.callback = null;
                    }
                }], [{
                    key: 'getQuery',
                    value: function getQuery(params, defaults) {
                        var query = {};
        
                        angular.forEach(params, function (value, key) {
                            if (key === 'where') {
                                return;
                            }
        
                            SearchParams.paramToQuery(query, key, value, defaults[key]);
                        });
        
                        angular.forEach(params.where, function (value, key) {
                            SearchParams.paramToQuery(query, key, value, defaults.where[key]);
                        });
        
                        return query;
                    }
                }, {
                    key: 'paramToQuery',
                    value: function paramToQuery(query, key, value, defaultValue) {
                        // If a value is the same as default, don't clutter the url
                        if (angular.equals(defaultValue, value)) {
                            return;
                        }
        
                        // Deal with non where parameters differently
                        if (SearchParams.notInWhere[key]) {
                            SearchParams.notInWhere[key].toQuery(query, key, value);
                            return;
                        }
        
                        // Allow for complex query operators
                        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
                            var conditions = [];
        
                            angular.forEach(value, function (val, operator) {
                                if (val === '') {
                                    return;
                                }
        
                                var opCode = SearchParams.inverseOperators[operator];
                                if (!opCode || operator === SearchParams.defaultOperator) {
                                    conditions.push(val);
                                } else {
                                    conditions.push(opCode + SearchParams.separator + val);
                                }
                            });
        
                            // We only support one condition per field atm
                            if (conditions.length) {
                                query[key] = conditions[0];
                            }
                            return;
                        }
        
                        if (value !== undefined && value !== '') {
                            query[key] = value;
                        }
                    }
                }, {
                    key: 'queryToParam',
                    value: function queryToParam(params, key, value) {
                        if (value === '') {
                            return;
                        }
        
                        // Deal with non where parameters differently
                        if (SearchParams.notInWhere[key]) {
                            SearchParams.notInWhere[key].toParam(params, key, value);
                            return;
                        }
        
                        // Default operator
                        var operator = SearchParams.defaultOperator;
        
                        // Are we using a more complex operator?
                        var matches = SearchParams.regExp.exec(value);
        
                        if (matches && SearchParams.operators[matches[1]]) {
                            operator = SearchParams.operators[matches[1]];
                            value = matches[2];
                        }
        
                        if (/^\d+$/.test(value)) {
                            value = parseInt(value);
                            operator = '==';
                        }
        
                        if (operator === '==') {
                            params.where[key] = value;
                        } else {
                            params.where[key] = {};
                            var decoder = SearchParams.operatorValueDecoders[operator] || SearchParams.operatorValueDecoders.default;
                            params.where[key][operator] = decoder(value);
                        }
                    }
                }]);
        return SearchParams;
    }();
    SearchParams.separator = ':';
    SearchParams.regExp = new RegExp('^(.+)' + SearchParams.separator + '(.*)$');
    SearchParams.defaultOperator = '===';
    SearchParams.operators = {
        '': '==',
        eq: '===',
        ne: '!=',
        neq: '!==',
        gt: '>',
        gte: '>=',
        lt: '<',
        lte: '<=',
        in: 'in',
        nin: 'notIn',
        c: 'contains',
        nc: 'notContains',
        search: 'likei',
        any: 'isectNotEmpty',
        all: 'isectEmpty'
    };
    SearchParams.operatorValueDecoders = {
        default: function _default(value) {
            return value;
        },
        in: function _in(value) {
            return value.split(',');
        },
        notIn: function notIn(value) {
            return value.split(',');
        },
        isectNotEmpty: function isectNotEmpty(value) {
            return value.split(',').map(Number);
        },
        isectEmpty: function isectEmpty(value) {
            return value.split(',').map(Number);
        }
    };
    var setRawInteger = function setRawInteger(object, key, value) {
        object[key] = parseInt(value);
    };
    var setString = function setString(object, key, value) {
        object[key] = value;
    };
    var basic = {
        toQuery: setRawInteger,
        toParam: setRawInteger
    };
    SearchParams.notInWhere = {
        limit: basic,
        offset: basic,
        sort: {
            toQuery: setString,
            toParam: setString
        }
    };
    SearchParams.inverseOperators = {};
    angular.forEach(SearchParams.operators, function (value, key) {
        SearchParams.inverseOperators[value] = key;
    });
    return SearchParams;
}]);
'use strict';
angular.module('ng-komondor-resource-view').factory('createAction', ["$state", function ($state) {
    return {
        name: 'create',
        buttonClass: 'btn btn-primary',
        template: '<i class="material-icon material-icon-add"></i> New',
        act: function act() {
            $state.go('.edit', { id: 0 });
        },
        show: function show() {
            return true;
        }
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').service('createFolderAction', ["$state", function ($state) {
    return {
        name: 'createFolder',
        buttonClass: 'btn btn-primary',
        template: '<i class="material-icon material-icon-create-folder"></i> Create folder',
        act: function act() {
            $state.go('.editFolder', { id: 0 });
        },
        show: function show() {
            return true;
        }
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').factory('deleteAction', ["$state", function ($state) {
    return {
        name: 'delete',
        tooltip: 'Delete',
        buttonClass: 'btn btn-default',
        template: '<i class="material-icon material-icon-delete"></i> Delete',
        act: function act(models) {
            var ids = [];
            for (var i = 0; i < models.length; i++) {
                ids.push(models[i].id);
            }
            $state.go('.delete', { ids: ids.join() });
        },
        show: function show(models) {
            return models.length > 0 && models.every(function (element) {
                return !element.deleted_at && element.editable !== false;
            });
        }
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').controller('DeleteCtrl', ["$scope", "$q", "models", "modelName", "modelNameField", "Model", "notify", function ($scope, $q, models, modelName, modelNameField, Model, notify) {
    $scope.models = models;
    $scope.modelName = modelName;
    $scope.modelNameField = modelNameField;
    $scope.dependencies = [];
    $scope.canDelete = false;
    $scope.hasDependencies = function (model) {
        model.dependencies = model.dependencies || [];
        return Object.keys(model.dependencies).length > 0;
    };
    angular.forEach($scope.models, function (model) {
        $scope.canDelete = $scope.canDelete || !$scope.hasDependencies(model);
    });
    $scope.deleteModels = function () {
        var promises = [];
        angular.forEach(models, function (model) {
            if (!$scope.hasDependencies(model)) {
                promises.push(model.DSDestroy());
            }
        });
        $q.all(promises).then(function () {
            $scope.$close();
            Model.ejectAll();
        }, function (response) {
            notify.alert(response.data, { title: 'Failed to delete' }).result.finally($scope.$dismiss);
        });
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').factory('deselectAction', function () {
    return {
        name: 'deselect',
        tooltip: 'Deselect all',
        buttonClass: 'btn btn-default',
        template: '<span>Deselect {{ models.length }}</span>',
        act: function act(models, options) {
            options.resourceList.clearSelected();
        },
        show: function show(models) {
            return models.length > 0;
        }
    };
});
'use strict';
angular.module('ng-komondor-resource-view').factory('editAction', ["$state", function ($state) {
    return {
        name: 'edit',
        tooltip: 'Edit',
        buttonClass: 'btn btn-default',
        template: '<i class="material-icon material-icon-edit"></i> Edit',
        act: function act(models) {
            if (models[0].type && models[0].type === 'folder') {
                $state.go('.editFolder', { id: models[0].id });
            } else {
                $state.go('.edit', { id: models[0].id });
            }
        },
        show: function show(models) {
            return models.length === 1 && models[0].editable !== false;
        }
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').controller('EditCtrl', ["$scope", "model", "modelNameField", function ($scope, model, modelNameField) {
    $scope.model = model;
    $scope.modelNameField = modelNameField;
    $scope.saveModel = function () {
        $scope.model.DSCreate(model, { upsert: true }).then($scope.$close);
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').controller('EditFolderCtrl', ["$scope", "model", "modelNameField", "tagging", function ($scope, model, modelNameField, tagging) {
    $scope.model = model;
    $scope.modelNameField = modelNameField;
    $scope.tagging = tagging;
    this.saveFolder = function () {
        $scope.model.DSCreate({ upsert: true }).then($scope.$close);
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').factory('moveAction', ["$state", function ($state) {
    return {
        name: 'move',
        tooltip: 'Move',
        buttonClass: 'btn btn-default',
        template: '<i class="material-icon material-icon-open-with"></i> Move',
        act: function act(models) {
            var ids = models.map(function (model) {
                return model.id;
            });
            $state.go('.move', { ids: ids.join() });
        },
        show: function show(models) {
            return models.length > 0 && models.every(function (element) {
                return !element.deleted_at && element.editable !== false;
            });
        }
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').controller('MoveCtrl', ["$scope", "$q", "models", "moveOptions", "Model", function ($scope, $q, models, moveOptions, Model) {
    $scope.options = {
        modelFolderKey: 'folder_id',
        folderParentKey: 'folder_id'
    };
    $scope.options = angular.extend($scope.options, moveOptions);
    $scope.models = models;
    $scope.modelName = Model.name;
    $scope.selected = { id: null };
    $scope.moveModels = function () {
        if ($scope.selected.id === null) {
            return;
        }
        var promises = [];
        angular.forEach($scope.models, function (model) {
            var defer = $q.defer();
            promises.push(defer.promise);
            model[$scope.options.modelFolderKey] = $scope.selected.id;
            model.DSSave().then(function () {
                defer.resolve();
            }).catch(function () {
                model.DSRevert();
            });
        });
        $q.all(promises).then(function () {
            $scope.$close();
        });
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').factory('recoverAction', ["$state", "$q", function ($state, $q) {
    return {
        name: 'recover',
        buttonClass: 'btn btn-danger',
        template: '<span class="glyphicon glyphicon-recover"></span>Recover',
        act: function act(models) {
            var promises = [];
            angular.forEach(models, function (model) {
                var defer = $q.defer;
                promises.push(defer.promise);
                model.deleted_at = null;    // model.$recover(defer.resolve, defer.reject);
            });
            $q.all(promises).then(function () {
                $state.go($state.current.name, {}, { reload: true });
            });
        },
        show: function show(models) {
            return models.length > 0 && models.every(function (element) {
                return element.deleted_at;
            });
        }
    };
}]).factory('toggleTrashAction', ["$state", function ($state) {
    return {
        name: 'toggle',
        text: 'Show Trash',
        buttonClass: 'btn btn-primary',
        template: '<span class="glyphicon glyphicon-trash"></span>{{ action.text }}',
        act: function act() {
            var params = { trash: $state.params.trash ? undefined : 'only' };
            $state.go($state.current.name, params, { reload: true });
        },
        show: function show() {
            if ($state.params.trash) {
                this.text = 'Hide Trash';
            } else {
                this.text = 'Show Trash';
            }
            return true;
        }
    };
}]);
'use strict';
angular.module('ng-komondor-resource-view').factory('gridNameTemplate', function () {
    return function (name) {
        var template = '<div class="field asset-title" uib-tooltip="{{ model.' + name + ' }}" tooltip-animation="false">' + '<span class="mr-1" ng-class="options.getIcon(model)"></span>' + '<span>{{ model.' + name + ' }}</span>' + '</div>';
        return template;
    };
});
'use strict';
angular.module('ng-komondor-resource-view').factory('gridThumbTemplate', function () {
    return function (thumb) {
        return '<div class="thumb-wrapper" ng-click="admin.goToModel($event, model)">' + '<div class="thumb-image"' + 'ng-if="model.' + thumb + '"' + 'ng-style="{\'background-image\': \'url(\' + model.' + thumb + ' + \')\'}"></div>' + '<span ng-class="options.getIcon(model, true)" ng-if="!model.' + thumb + '"></span>' + '</div>';
    };
});
'use strict';
angular.module('ng-komondor-resource-view').factory('listNameTemplate', function () {
    return function (name, thumb) {
        return '<p class="resource-ui-name">\n            ' + (thumb ? '<span class="thumb-wrap" ng-click="admin.goToModel($event, model)">\n                            <span ng-if="model.' + thumb + '"\n                                  class="thumb"\n                                  picture="model.' + thumb + '"></span>\n                            <i ng-if="!model.' + thumb + '"\n                               class="icon"\n                               ng-class="options.getIcon(model)"></i>\n                        </span>' : '') + '\n                        <span class="asset-wrap">\n                            <span class="asset-title"\n                                  ng-click="admin.goToModel($event, model)">{{ model.name }}</span>\n                            <span class="asset-breadcrumbs"\n                                  ng-if="options.showBreadcrumbs && model.breadcrumbs.length">\n                            in <span ng-repeat="breadcrumb in model.breadcrumbs">\n                                <a ng-click="$event.stopPropagation(); admin.goToFolder(breadcrumb.id)">{{ breadcrumb.label }}</a> {{ $last ? "" : ">" }}\n                                </span>\n                            </span>\n                        </span>\n                    </p>';
    };
});
'use strict';
angular.module('ng-komondor-resource-view').factory('gridView', function () {
    return {
        label: 'grid',
        buttonClass: 'btn',
        iconClass: 'material-icon material-icon-view-module',
        templateUrl: 'ng-komondor-resource-view/grid.html'
    };
});
'use strict';
angular.module('ng-komondor-resource-view').factory('listView', function () {
    return {
        label: 'list',
        buttonClass: 'btn',
        iconClass: 'material-icon material-icon-view-list',
        templateUrl: 'ng-komondor-resource-view/list.html'
    };
});
'use strict';
angular.module('ng-komondor-resource-view').filter('tagContainsId', function () {
    return function (input, data, disabled) {
        if (disabled) {
            return [];
        }
        if (!input || !input.length) {
            return [];
        }
        return input.filter(function (item) {
            return !!data[item.id];
        });
    };
}).filter('tagNotContainsId', function () {
    return function (input, data, disabled) {
        if (disabled) {
            return input;
        }
        if (!input || !input.length) {
            return input;
        }
        return input.filter(function (item) {
            return !data[item.id];
        });
    };
});
'use strict';
angular.module('ng-komondor-resource-view.templates', []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("ng-komondor-resource-view/delete.html", "<form ng-submit=\"deleteModels()\"><div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">Delete {{ models.length }} item{{models.length === 1 ? \'\' : \'s\'}}</h1></div><div class=\"modal-body text-center\"><div class=\"row\"><div class=\"col-xs-12\"><h3>Are you sure you want to delete:</h3><div ng-repeat=\"model in models\" class=\"dependencies\" ng-class=\"{danger: hasDependencies(model)}\"><h3 class=\"model-name\">{{ model[modelNameField] }}</h3><div ng-if=\"hasDependencies(model)\" class=\"dependencies-list\"><div class=\"dependency-head\">Dependencies:</div><div ng-repeat=\"(class, depList) in model.dependencies\" class=\"dependency\"><span class=\"dependency-name\">{{class}}:</span><span ng-repeat=\"dep in depList\" class=\"dependency-item\"><a ng-if=\"dep.url\" href=\"{{dep.url}}\">{{dep.dependName}}</a><span ng-if=\"!dep.url\">{{dep.name}}</span><span ng-if=\"!$last\">,</span></span></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"$dismiss()\">Cancel</button></div><div class=\"col-xs-6\" ng-if=\"canDelete\"><button type=\"submit\" class=\"btn btn-primary btn-block\" autofocus>OK</button></div></div></div></form>");
  $templateCache.put("ng-komondor-resource-view/edit-folder.html", "<form ng-submit=\"$ctrl.saveFolder()\"><div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">{{ model.id ? \'Edit\' : \'New\'; }} folder</h1></div><div class=\"modal-body\"><div form-group=\"name\"><label for=\"title-field\">Name</label><input id=\"title-field\" class=\"form-control\" type=\"text\" ng-model=\"model[modelNameField]\" required></div><div><dropdown-permissions model=\"model\"></div><tags-edit model=\"model\" ng-if=\"tagging\"></tags-edit></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"$dismiss()\">Cancel</button></div><div class=\"col-xs-6\"><button type=\"submit\" class=\"btn btn-primary btn-block\">Save</button></div></div></div></form>");
  $templateCache.put("ng-komondor-resource-view/edit.html", "<form ng-submit=\"saveModel()\"><div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">{{ model.id ? \'Edit\' : \'New\'; }} {{ ::model.type }}</h1></div><div class=\"modal-body\"><div form-group=\"name\"><label class=\"control-label\" for=\"name\">Name</label><input type=\"text\" class=\"form-control\" ng-model=\"model[modelNameField]\" id=\"name\" autofocus></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"$dismiss()\">Cancel</button></div><div class=\"col-xs-6\"><button type=\"submit\" class=\"btn btn-primary btn-block\" autofocus>Save</button></div></div></div></form>");
  $templateCache.put("ng-komondor-resource-view/filter.html", "<div class=\"filter\"><div class=\"filter-toggle\" ng-click=\"sidemenu.toggle = !sidemenu.toggle\">+</div><h3>Filter by:</h3><div class=\"filter-options\" ng-repeat=\"filter in model.filters\"><label for=\"type\">{{filter.name}}</label><select id=\"type\" class=\"form-control\" ng-model=\"filter.selected\" ng-options=\"option for option in filter.options\"></select></div></div>");
  $templateCache.put("ng-komondor-resource-view/grid.html", "<ul class=\"resource-grid clearfix\" ng-class=\"$ctrl.options.grid.gridClass\"><li ng-repeat=\"model in $ctrl.resourceList.all track by model.id\"><div class=\"resource-grid-item\" ng-click=\"$ctrl.resourceList.click(model, $event)\" kd-dbltap=\"$ctrl.goToModel($event, model)\" ng-class=\"$ctrl.options.rowClassifier(model, {selected: $ctrl.resourceList.isSelected(model)})\"><div ng-repeat=\"field in $ctrl.options.grid.fields\" ng-class=\"field.divClass\" standard-field=\"field\" model=\"model\" options=\"$ctrl.options\" admin=\"$ctrl\"></div></div></li></ul><div class=\"resource-grid-footer\" ng-include=\" ::$ctrl.options.footerTemplate \"></div>");
  $templateCache.put("ng-komondor-resource-view/list.html", "<table class=\"resource-list\" ng-class=\"$ctrl.options.list.tableClass\"><thead><tr><th ng-repeat=\"field in $ctrl.options.list.columns track by $index\">{{ field.label }}</th></tr></thead><tbody><tr class=\"resource-ui-{{model.type}}\" ng-repeat=\"model in $ctrl.resourceList.all track by model.id\" ng-click=\"$ctrl.resourceList.click(model, $event)\" kd-dbltap=\"$ctrl.goToModel($event, model)\" ng-class=\"$ctrl.options.rowClassifier(model, {selected: $ctrl.resourceList.isSelected(model)})\"><td ng-repeat=\"field in $ctrl.options.list.columns\" standard-field=\"field\" model=\"model\" options=\"$ctrl.options\" admin=\"$ctrl\"></td></tr></tbody></table><div class=\"resource-list-footer\" ng-include=\" ::$ctrl.options.footerTemplate \"></div>");
  $templateCache.put("ng-komondor-resource-view/move.html", "<form ng-submit=\"moveModels()\"><div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">Move {{ models.length }} item{{models.length === 1 ? \'\' : \'s\'}}</h1></div><div class=\"modal-body\"><div form-group=\"folder_id\"><label for=\"folder_id\">Move to</label><div class=\"row\"><div class=\"col-xs-12\" id=\"folder_id\" folder-picker resource-picker=\"{{ modelName }}\" ng-model=\"selected.id\"></div></div></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"$dismiss()\">Cancel</button></div><div class=\"col-xs-6\"><button ng-disabled=\"selected.id === null\" type=\"submit\" class=\"btn btn-primary btn-block\">Move</button></div></div></div></form>");
  $templateCache.put("ng-komondor-resource-view/resource-picker-control.html", "<div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" id=\"{{ buttonId }}\" class=\"btn btn-default\" ng-click=\"openResourcePicker()\" title=\"Choose\">Choose</button></span><span class=\"form-control\" readonly>{{ getDescription() }}</span><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"clear()\" title=\"Clear\"><i class=\"material-icon material-icon-close\"></i></button></span></div>");
  $templateCache.put("ng-komondor-resource-view/resource-picker.html", "<div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">{{ $ctrl.options.modalTitle }}</h1></div><div class=\"modal-body\"><div ng-include=\"\'ng-komondor-resource-view/ribbon.html\'\"></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-offset-3 col-xs-3\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"$dismiss()\">Cancel</button></div><div class=\"col-xs-3\" ng-show=\"$ctrl.options.chooseSelected.show($ctrl.resourceList.selected)\"><button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"$ctrl.options.chooseSelected.act($ctrl.resourceList.selected)\">Choose selected</button></div><div class=\"col-xs-3\" ng-hide=\"!$ctrl.options.chooseCurrent.show($ctrl.resourceList.selected)\"><button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"$ctrl.options.chooseCurrent.act($ctrl.resourceList.selected)\">Choose current</button></div></div></div>");
  $templateCache.put("ng-komondor-resource-view/ribbon.html", "<div class=\"resource-view\" ng-class=\"::$ctrl.name\"><div class=\"row\"><div class=\"col-xs-7\"><ul class=\"breadcrumb\" ng-show=\"$ctrl.breadcrumbs.title\"><li ng-repeat=\"crumb in $ctrl.breadcrumbs.list\"><a href=\"\" ng-click=\"crumb.go ? crumb.go(crumb.id) : $ctrl.goToFolder(crumb.id)\">{{ crumb.name }}</a></li><li>{{ $ctrl.breadcrumbs.title }}</li></ul></div><div class=\"col-xs-5\"><div class=\"toolbar clearfix\" ng-show=\"$ctrl.options.toolbar.length\"><div class=\"pull-right\"><button ng-repeat=\"action in $ctrl.options.toolbar\" ng-class=\"action.buttonClass\" standard-action=\"action\" models=\"$ctrl.resourceList.selected\" options=\"$ctrl.options\" ng-show=\"action.show()\" ng-click=\"action.act(null, $ctrl.options, $ctrl.params)\"></button></div></div></div></div><div class=\"resource-filters\" ng-include src=\"$ctrl.options.filters.templateUrl\"></div><div class=\"navbar navbar-default\" sticky z-index=\"999\" off-set=\"stickyOffset\" role=\"toolbar\"><div id=\"ribbon-actions\" class=\"btn-group btn-group-sm\"><button ng-repeat=\"action in $ctrl.options.actions\" ng-class=\"action.buttonClass\" standard-action=\"action\" models=\"$ctrl.resourceList.selected\" options=\"$ctrl.options\" admin=\"$ctrl\" ng-show=\"action.show($ctrl.resourceList.selected, $ctrl.options, $ctrl.params)\" ng-click=\"action.act($ctrl.resourceList.selected, $ctrl.options, $ctrl.params)\" uib-tooltip=\"{{ action.tooltip || action.name }}\"></button></div><div id=\"ribbon-filters\" class=\"pull-right btn-group btn-group-sm\"><button id=\"resource-tags-ui\" class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.toggleTagPool()\" ng-if=\"$ctrl.options.tagging && $ctrl.tags.pool.length > 0\" uib-tooltip=\"Show/hide&nbsp;tag&nbsp;filter\"><span>{{ $ctrl.tags.show ? \'Hide \' : \'Show \' }}</span>tags</button><div id=\"resource-pagination-ui\" class=\"btn-group btn-group-sm\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.paging.prev()\" ng-disabled=\"$ctrl.paging.page === 1\" uib-tooltip=\"Previous page\"><i class=\"material-icon material-icon-keyboard-arrow-left\"></i></button><div class=\"btn btn-static resource-info\"><span>{{ $ctrl.resourceInfo }}</span></div><button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.paging.next()\" ng-disabled=\"$ctrl.paging.page === $ctrl.paging.getLastPage()\" uib-tooltip=\"Next&nbsp;page\"><i class=\"material-icon material-icon-keyboard-arrow-right\"></i></button></div><div uib-dropdown id=\"resource-limit-ui\" class=\"btn-group btn-group-sm hidden-xs\" uib-tooltip=\"Items per page\"><button uib-dropdown-toggle class=\"btn btn-default\"><span>Show: {{ $ctrl.params.limit }}&nbsp;</span><span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"option in $ctrl.options.limitOptions\"><button class=\"btn btn-default btn-block\" ng-click=\"$ctrl.setLimit(option)\">{{ option }}</button></li></ul></div><button class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.toggleSortDirection()\" uib-tooltip=\"Sort direction\"><i class=\"material-icon\" ng-class=\"{\'material-icon-arrow-downward\': $ctrl.sortReversed, \'material-icon-arrow-upward\': !$ctrl.sortReversed}\"></i></button><div uib-dropdown uib-keyboard-nav id=\"resource-sort-ui\" class=\"btn-group btn-group-sm\"><button uib-dropdown-toggle class=\"btn btn-default\" uib-tooltip=\"Sort by\"><span>Sort by: {{ $ctrl.selectedSort.label }}&nbsp;</span><span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"sort in $ctrl.sorts\"><button class=\"btn btn-default btn-block\" ng-click=\"$ctrl.setSort(sort.sort)\">{{ sort.label }}</button></li></ul></div><div ng-repeat=\"filter in $ctrl.resourceFilters\" uib-dropdown uib-keyboard-nav class=\"btn-group btn-group-sm\"><button uib-dropdown-toggle class=\"btn btn-default\" uib-tooltip=\"Sort by\"><span>{{ filter.label }}: {{ $ctrl.filtersSelected[filter.value] }} &nbsp;</span><span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"option in filter.options\"><button class=\"btn btn-default btn-block\" ng-click=\"$ctrl.setResourceFilter(filter, option)\">{{ option.label }}</button></li></ul></div><kd-search class=\"btn-group btn-group-sm\" field=\"$ctrl.modelNameField\" value=\"$ctrl.params.where[$ctrl.modelNameField].likei\" on-change=\"$ctrl.searchChanged(search)\"></kd-search><button id=\"resource-view-mode\" type=\"button\" class=\"btn btn-sm btn-default\" ng-class=\"$ctrl.ribbon.nextView.buttonClass\" ng-click=\"$ctrl.ribbon.goToNextView()\" ng-if=\"$ctrl.options.views.length > 1\" uib-tooltip=\"Grid/list&nbsp;view\"><i class=\"glyphicon\" ng-class=\"$ctrl.ribbon.nextView.iconClass\"></i></button></div></div><div class=\"tag-pool\" ng-show=\"$ctrl.tags.show && $ctrl.tags.pool.length > 0\"><div><button type=\"button\" class=\"tag btn btn-xs btn-primary\" ng-class=\"{\'active\': $ctrl.tags.filter[tag.id]};\" uib-btn-checkbox ng-repeat=\"tag in $ctrl.tags.pool | tagNotContainsId:$ctrl.tags.filter:!$ctrl.tags.advanced | orderBy:\'name\'\" ng-model=\"$ctrl.tags.filter[tag.id]\" ng-change=\"$ctrl.tagFilterChanged()\">{{ tag.name }}<span class=\"badge\">{{ tag.count }}</span></button></div><div ng-if=\"$ctrl.tags.advanced && !$ctrl.tags.isEmpty()\"><div class=\"tag-filter\">Showing items tagged with<button class=\"tag-filter-btn\" ng-click=\"$ctrl.tags.filterAny = !$ctrl.tags.filterAny; $ctrl.tagFilterChanged()\"><span>{{ $ctrl.tags.filterAny ? \'ANY\' : \'ALL\' }}</span></button>of:</div><button type=\"button\" class=\"tag btn btn-xs btn-primary\" ng-class=\"\'active\'\" uib-btn-checkbox ng-repeat=\"tag in $ctrl.tags.pool | tagContainsId:$ctrl.tags.filter:false | orderBy:\'name\'\" ng-model=\"$ctrl.tags.filter[tag.id]\" ng-change=\"$ctrl.tagFilterChanged()\">{{ tag.name }}<span class=\"badge\">{{ tag.count }}</span></button></div></div><div class=\"ribbon-view\" ng-include src=\"$ctrl.ribbon.view.templateUrl\"></div></div>");
  $templateCache.put("ng-komondor-resource-view/tree-folder.html", "<div class=\"tree-folder\" ng-class=\"{selected: options.isSelected(treeish)}\"><span class=\"glyphicon glyphicon-folder-close\" ng-if=\"treeish.children.length && !treeish.open\" ng-click=\"toggle()\"></span><span class=\"glyphicon glyphicon-folder-open\" ng-if=\"treeish.children.length && treeish.open\" ng-click=\"toggle()\"></span><span class=\"glyphicon glyphicon-folder-open glyphicon-folder-empty\" ng-if=\"!treeish.children.length\"></span><span class=\"tree-folder-name\" ng-click=\"toggle(); options.select(treeish)\">{{ treeish.model.name }}</span></div>");
  $templateCache.put("ng-komondor-resource-view/search/search.html", "<div id=\"resource-search-ui\" class=\"input-group\" ng-class=\"{active: $ctrl.active || $ctrl.value}\" uib-tooltip=\"Search\"><form class=\"navbar-form\"><button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.toggleActive();\"><i class=\"material-icon material-icon-search\"></i></button><div class=\"form-group form-group-sm\"><span class=\"sr-only\">Search</span><input type=\"search\" id=\"resource-search\" class=\"form-control input-search\" ng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\" ng-model=\"$ctrl.value\" ng-keydown=\"handleKeyDown($event)\" ng-change=\"$ctrl.emitChange()\" ng-trim=\"false\" ng-minlength=\"3\" placeholder=\"Search\" focus-me=\"$ctrl.active\"><div class=\"input-field-clear\"><span class=\"material-icon material-icon-clear\" aria-hidden=\"true\" ng-show=\"$ctrl.value\" ng-click=\"$ctrl.clear()\"></span></div></div></form></div>");
}]);
})();

//# sourceMappingURL=ng-komondor-resource-view.js.map
